export class Kundenbetreuer {
    public id: string;
    public vorname: string;
    public nachname: string;
}
